// ── Field ─────────────────────────────────────────────────────────────────────
// Label + optional hint + content row. Used in settings-style forms.
// Replaces the local FieldRow helper that existed in SettingsPage.

import { type ReactNode } from 'react';

interface Props {
  label: string;
  hint?: string;
  children: ReactNode;
}

export function Field({ label, hint, children }: Props) {
  return (
    <div
      className="flex items-start gap-6 py-2"
      style={{ borderBottom: '1px solid var(--evo-stroke)' }}
    >
      <div style={{ width: '160px', flexShrink: 0 }}>
        <p className="text-sm" style={{ color: 'var(--evo-fg-2)' }}>{label}</p>
        {hint && (
          <p className="text-xs mt-0.5" style={{ color: 'var(--evo-fg-3)' }}>{hint}</p>
        )}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}
